define('modules/editor/services/copy_paste/index',['require','exports','module','../../../../lib/localStorage','../../models/element_factory','../../models/editorstate','../../views/copypaste_popup','i18n'],function(require,exports,module){
  'use strict';

  var localStorage = require('../../../../lib/localStorage'),
    ElementFactory = require('../../models/element_factory'),
    EditorState = require('../../models/editorstate'),
    CopyPastePopup = require("../../views/copypaste_popup"),
    i18n = require('i18n');

  var // copy

    getElements = function () {
      var selectedElements = EditorState.groupState.elements.models;
      return _.reduce(selectedElements, function (result, model) {
        var view = model.get('view');
        if (view && view.model && view.model.toJSON) {
          result.push(view.model.toJSON());
        }
        return result;
      }, []);
    },

    showNoticeOnCopy = function (elements, callback) {
      var sizeElements = _.size(elements),
        key;
      switch (sizeElements) {
        case 0:
          key = 'copied_0';
          break;
        case 1:
          key = 'copied_1';
          break;
        default:
          key = 'copied_several';
      }
      callback(i18n.t('editor.copyPaste.' + key, { size: sizeElements }));
    },

    // paste

    isAddingArea = false,
    addElements = function (parent, elements) {
      _.each(elements, function (element) {
        var area;
        if (element.name === 'element:area') {
          isAddingArea = true;
          area = createAreaElement(parent, element);
          area.setPosition({x: 0, y: 0});
          addElements(area, element.elements);
          addToParent(parent, area);
          isAddingArea = false;
        } else {
          element = createNormalElement(element);
          if (!isAddingArea) element.setPosition({x: 0, y: 0});
          addToParent(parent, element);
        }
      });
    },

    createNormalElement = function (element) {
      removeIdClassPropertyGroup(element);
      return ElementFactory.create(element.name, element);
    },

    createAreaElement = function (parent, element) {
      removeIdClassPropertyGroup(element);
      return parent.addArea(element);
    },

    removeIdClassPropertyGroup = function (element) {
      element.properties = _.filter(element.properties, function (property) {
        return property.name !== 'idclass';
      });
    },

    addToParent = function (parent, element) {
      if (parent && parent.addElement) {
        parent.addElement(element);
      }
    },

    showNoticeOnPaste = function (selectedElement, elements, callback) {
      var sizeElements = _.size(elements),
        key;
      if (!selectedElement || !selectedElement.model || !selectedElement.model.addElement) {
        callback(i18n.t('editor.copyPaste.selectSectionOrAreaToPaste'));
      } else {
        switch (sizeElements) {
          case 0:
            key = 'pasted_0';
            break;
          case 1:
            key = 'pasted_1';
            break;
          default:
            key = 'pasted_several';
        }
        callback(i18n.t('editor.copyPaste.' + key, { size: sizeElements }));
      }
    };

  module.exports = {

    copy: function(callback) {
      var elements = getElements();
      localStorage.set('copyPasteElements', getElements());
      showNoticeOnCopy(elements, callback);
    },

    paste: function(callback) {
      var selectedElement = EditorState.getSelectedElement(),
        copiedElements = localStorage.get('copyPasteElements');
      if (selectedElement && selectedElement.model && !_.isEmpty(copiedElements)) {
        CopyPastePopup.show(copiedElements)
          .then(function(element){
            EditorState.getActivePage().deleteItem(element);
            addElements(selectedElement.model, copiedElements);
            showNoticeOnPaste(selectedElement, copiedElements, callback);
          });
      }
    }

  };

});

